import { render, staticRenderFns } from "./ChangeDataPopup.vue?vue&type=template&id=31db7180&scoped=true"
import script from "./ChangeDataPopup.vue?vue&type=script&lang=js"
export * from "./ChangeDataPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db7180",
  null
  
)

export default component.exports